import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { createContinueBtn } from './continueBtn';
import { createHotSpotBlock } from './hotspot_isolated';
import { createFeedbackBlock } from './feedback';
import { getSId } from '../utils';

export type HotSpotInteractionProps = InteractionProps & {
  answerCount: number;
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createBlock('Text', [], { props: { useBackgroundControls: true } }),
    () =>
      createBlock('HotSpotScorable', [
        createHotSpotBlock({}),
        createFeedbackBlock({
          label: 'Submit',
        }),
      ]),
    // () => createHotSpotBlock({}),
  ][i];
};

export const createHotSpotInteractionBlock = (
  props: HotSpotInteractionProps
) => {
  const {
    lockDown = 0,
    style,
    score,
    immediateFeedback,
    isGlobalNavigation,
    isHotspotLandingPage,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(props.answerCount), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        lockDown,
        score,
        immediateFeedback,
        isGlobalNavigation,
        isHotspotLandingPage,
      },
      meta: {
        subType: 'HotSpot',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createHotSpotInteractionBlock;
export const interactionConfig = {};
